import {RememberMeToken} from '@commons/models/domain/RememberMeToken';

export class RememberMeTokenStore {

  private readonly tokenLSKey = 'remember-me-token';
  private _token?: RememberMeToken;

  get token(): RememberMeToken | undefined {
    if (!this._token) {
      const item = localStorage.getItem(this.tokenLSKey);
      this._token = item ? JSON.parse(item) as RememberMeToken : undefined;
    }
    return this._token?.value ? JSON.parse(JSON.stringify(this._token)) : undefined;
  }

  constructor() {
  }

  save(newToken: RememberMeToken) {
    this._token = JSON.parse(JSON.stringify(newToken));
    localStorage.setItem(this.tokenLSKey, JSON.stringify(this._token));
  }

  clear() {
    localStorage.removeItem(this.tokenLSKey);
  }
}
